import { addDownloadParam } from '../../utils/urlUtils';

export class SignatureVMAvenant {
  condPUrlEmbed!: string | undefined;
  sepaUrlEmbed!: string | undefined;

  condPUrlDl!: string;
  sepaUrlDl!: string;

  isCondPSigned: boolean;
  isSepaSigned: boolean;

  condPLoaded: boolean;
  sepaLoaded: boolean;
  constructor(condPUrl: string, sepaUrl: string) {
    this.condPUrlEmbed = condPUrl;
    this.sepaUrlEmbed = sepaUrl;

    this.isCondPSigned = false;
    this.isSepaSigned = false;

    this.condPLoaded = false;
    this.sepaLoaded = false;

    this.condPUrlDl = addDownloadParam(condPUrl);
    this.sepaUrlDl = addDownloadParam(sepaUrl);
  }
}
